import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  color: PropTypes.oneOf([
    '',
    'primary',
    'secondary',
    'success',
    'error',
  ]),
  square: PropTypes.bool,
};

const defaultProps = {
  classes: {
    root: '',
  },
  color: '',
  square: false,
};

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 20,
    padding: theme.spacing(1, 4),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: theme.spacing(14),
  },
  square: {
    borderRadius: 4,
    padding: theme.spacing(1, 2),
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

const DefaultButton = React.forwardRef((props, ref) => {
  const cls = useStyles();
  const {
    classes, color, square, ...others
  } = props;
  return (
    <Button
      ref={ref}
      classes={{
        root: clsx(
          cls.root,
          cls[color],
          { [cls.square]: square },
          classes.root,
        ),
      }}
      size="small"
      variant="contained"
      {...others}
    />
  );
});

DefaultButton.propTypes = propTypes;
DefaultButton.defaultProps = defaultProps;

export default DefaultButton;
